import { userActivityLogActionTypes } from './userActivityLog.types';

const initialState = {
    logs: [],
    statistics: null,
    loading: false,
    error: null,
    total: 0,
    limit: 50,
    offset: 0
};

const userActivityLogReducer = (state = initialState, action) => {
    switch (action.type) {
        case userActivityLogActionTypes.SET_USER_ACTIVITY_LOGS:
            return {
                ...state,
                logs: action.payload.data || [],
                total: action.payload.total || 0,
                limit: action.payload.limit || 50,
                offset: action.payload.offset || 0
            };
        
        case userActivityLogActionTypes.SET_USER_ACTIVITY_LOG_STATISTICS:
            return {
                ...state,
                statistics: action.payload
            };
        
        case userActivityLogActionTypes.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        
        case userActivityLogActionTypes.SET_ERROR:
            return {
                ...state,
                error: action.payload
            };
        
        default:
            return state;
    }
};

export default userActivityLogReducer;
